import { render, staticRenderFns } from "./TextAreaEditor.vue?vue&type=template&id=fea5c126"
import script from "./TextAreaEditor.vue?vue&type=script&lang=ts"
export * from "./TextAreaEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports